module.exports = __webpack_public_path__ + "img/zero-days-off-book.14fae877.png";